import { darken, makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {},
  tableHead: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '3fr 3fr 3fr 3fr 3fr 1fr',
    color: 'gray',
    alignItems: 'center',
    padding: '0 0 0 12px',
    marginBottom: 4,
    marginTop: 4,
    backgroundColor:
      theme.palette.type === 'dark'
        ? darken(theme.palette.background.default, 0.3)
        : '#f7f7f7',
    borderRadius: 12,
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '15fr 1fr'
    }
  },
  tableHeadMobile: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '7fr 1fr',
    color: 'gray',
    padding: '0 0 0 12px',
    marginBottom: 4,
    marginTop: 4,
    backgroundColor:
      theme.palette.type === 'dark'
        ? darken(theme.palette.background.default, 0.3)
        : '#f7f7f7',
    borderRadius: 12,
    alignItems: 'center'
  },
  tableRow: {
    display: 'grid',
    gridTemplateColumns: '3fr 3fr 3fr 3fr 3fr 1fr',
    height: 100,
    alignItems: 'center',
    backgroundColor: theme.palette.background.default,
    borderRadius: 20,
    cursor: 'pointer',
    paddingLeft: 12,
    transition: 'background-color 0.3s ease-in-out',
    width: '100%',
    textAlign: 'unset',
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '15fr 1fr'
    },
    '&:hover': {
      backgroundColor:
        theme.palette.type === 'dark'
          ? darken(theme.palette.background.default, 0.3)
          : '#f0f0f0'
    }
  },
  tableRowForSmallScrren: {
    height: 50
  },
  tableRowMobile: {
    display: 'grid',
    gridTemplateColumns: '7fr 1fr',
    height: 100,
    alignItems: 'center',
    backgroundColor: theme.palette.background.default,
    transition: 'background-color 0.3s ease-in-out',
    borderRadius: 20,
    cursor: 'initial',
    paddingLeft: 12,
    '&:hover': {
      backgroundColor:
        theme.palette.type === 'dark'
          ? darken(theme.palette.background.default, 0.3)
          : '#f0f0f0'
    }
  },
  userLogo: {
    width: 60,
    height: 60,
    borderRadius: '50%',
    background: '#dfdfdf',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 12
  },
  nameCell: {
    display: 'flex'
  },
  moreIcon: {
    cursor: 'pointer'
  },
  refreshButtonContainer: {
    margin: 'auto'
  },
  editButtonContainer: {
    margin: 'auto'
  },
  skeleton: {
    width: '80%'
  },
  userInfoContainerSkeleton: {
    width: '80%'
  },
  userInfoNameSkeleton: {
    width: '80%'
  },
  EditIcon: {
    fontSize: 18,
    marginRight: 12
  },
  skeletonForEdit: {
    width: '40%',
    marginRight: 24
  }
}))

export default useStyles
